import {IItemStateModel} from "../base-itemstate";
import {IPropertyListingModel} from "../property";

export interface IBuiding extends IItemStateModel{
	Id?: number;
	ProjectId?: number;
	OrderByBuilding?: number;
	PhaseNumber?: number;
	Description?: IBuildingTranslation;
	Units?: IBuildingUnit[];
	PhaseInfo?: IItemStateModel;
	TotalUnits?: number;
}
export class Building implements IBuiding{
	Id?: number;
	ProjectId?: number;
	OrderByBuilding?: number;
	PhaseNumber?: number;
	Description?: IBuildingTranslation;
	Units?: IBuildingUnit[];
	PhaseInfo?: IItemStateModel;
	TotalUnits?: number;
	
	constructor(props?: IBuiding) {
		Object.keys(props).forEach(key => this[key] = props[key]);
	}
	
}
export interface IBuildingTranslation {
	BuildingId?: number;
	DeliveryNL?:string;
	DeliveryFR?:string;
	DeliveryEN?:string;
	DescriptionNL?:string;
	DescriptionFR?:string;
	DescriptionEN?:string;
	PriceHeaderNL?:string;
	PriceHeaderFR?:string;
	PriceHeaderEN?:string;
	PriceFooterNL?:string;
	PriceFooterFR?:string;
	PriceFooterEN?:string;
}

export interface IBuildingUnit extends IPropertyListingModel{
	BuildingId?: number;
	UnitType?: number;
	Reference?: string;
	TotalArea?: number;
	GardenSize?: number;
	HasGarden?: boolean;
	HasTerrace?: boolean;
	TerraceArea?: number;
	NumberOfBedRoom?: number;
	Floor?: number;
	Price?: number;
	SubStatusId?: number;
	IsPublishPrice?: boolean;
	UnitOrder?: number;
	StatusId?: number;
	IsAnnex?: boolean;
	SubStatusDate?: string;
	StatusChangeComment?: string;
	ContractTypeId?: number;
	Record?: string;
	Map?: string;
	UnitTypeInfo?: IItemStateModel;
	StatusInfo?: IItemStateModel;
	SubStatusInfo?: IItemStateModel;
}

export class BuildingTranslation implements IBuildingTranslation{
	BuildingId?: number;
	DeliveryNL?:string;
	DeliveryFR?:string;
	DeliveryEN?:string;
	DescriptionNL?:string;
	DescriptionFR?:string;
	DescriptionEN?:string;
	PriceHeaderNL?:string;
	PriceHeaderFR?:string;
	PriceHeaderEN?:string;
	PriceFooterNL?:string;
	PriceFooterFR?:string;
	PriceFooterEN?:string;
	constructor(props?: IBuildingTranslation) {
		this.BuildingId = props.BuildingId || null;
		this.DeliveryNL = props.DeliveryNL;
		this.DeliveryFR = props.DeliveryFR;
		this.DeliveryEN = props.DeliveryEN;
		this.DescriptionNL = props.DescriptionNL;
		this.DescriptionFR = props.DescriptionFR;
		this.DescriptionEN = props.DescriptionEN;
		this.PriceHeaderNL = props.PriceHeaderNL;
		this.PriceHeaderFR = props.PriceHeaderFR;
		this.PriceHeaderEN = props.PriceHeaderEN;
		this.PriceFooterNL = props.PriceFooterNL;
		this.PriceFooterFR = props.PriceFooterFR;
		this.PriceFooterEN = props.PriceFooterEN;
	}
}